module.exports = __webpack_public_path__ + "static/media/slow-creative-arrow-up-wht.4714c2b2.svg";